"use client";

var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
const PolygonMask = _ref => {
  let {
    title,
    description,
    children,
    contentClassName,
    maskDescriptionClassName,
    maskTitleClassName,
    button,
    maskPath,
    maskGradient,
    mobileClipPath,
    mobileGradient
  } = _ref;
  const {
    0: clipPathClass,
    1: setClipPathClass
  } = useState(maskPath);
  const {
    0: bgGradientClass,
    1: setBgGradientClass
  } = useState(maskGradient);
  useEffect(() => {
    const updateClipPathClass = () => {
      window.innerWidth <= 640 ? setClipPathClass(mobileClipPath) : setClipPathClass(maskPath);
    };
    const updateBgGradientClass = () => {
      window.innerWidth <= 640 ? setBgGradientClass(mobileGradient) : setBgGradientClass(maskGradient);
    };
    updateClipPathClass();
    updateBgGradientClass();
    window.addEventListener("resize", updateClipPathClass);
    window.addEventListener("resize", updateBgGradientClass);
    return () => {
      window.removeEventListener("resize", updateClipPathClass);
      window.removeEventListener("resize", updateBgGradientClass);
    };
  }, []);
  return __jsx("div", {
    className: "flex flex-col flex-wrap relative w-auto h-full sm:justify-end"
  }, __jsx("div", {
    className: "h-[398px] sm:h-[519px] "
  }, children), __jsx("div", {
    className: "absolute w-full h-full flex justify-center top-60 left-0 pr-0 sm:pr-32 sm:w-[45vw] sm:min-w-[600px] sm:top-0",
    style: {
      clipPath: clipPathClass !== null && clipPathClass !== void 0 ? clipPathClass : "none",
      backgroundImage: bgGradientClass !== null && bgGradientClass !== void 0 ? bgGradientClass : "none"
    }
  }, __jsx("div", {
    className: contentClassName
  }, title && __jsx("p", {
    className: maskTitleClassName
  }, title), description && __jsx("p", {
    className: maskDescriptionClassName
  }, description), button && __jsx("div", null, button))));
};
export default PolygonMask;